



































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AgencyDto from '@/models/Agencies/AgencyDto';
import UpdateAgencyGeneralDetailsRequest from '@/models/Agencies/UpdateAgencyGeneralDetailsRequest';
import Validator from '@/lib/validator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';

@Component({
    name: 'AgencyGeneralDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new AgencyDto();
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.agency));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAgencyGeneralDetailsRequest()
    request.updatedAt = AgencySettingsModule.agency.updatedAt;
    request.registeredName = this.entity.registeredName;
    request.buildingNameNumber = this.entity.buildingNameNumber;
    request.streetRoadBlock = this.entity.streetRoadBlock;
    request.cityTown = this.entity.cityTown;
    request.stateProvinceRegion = this.entity.stateProvinceRegion;
    request.postZipCode = this.entity.postZipCode;
    request.countryCode = this.entity.countryCode;
    request.registrationNumber = this.entity.registrationNumber;
    request.taxNumber = this.entity.taxNumber;
    await AgencySettingsModule.editAgencyGeneralDetails(request)
    this.dialog = false;
  }
}
